import React from "react"
import {
  NoSuggestedBox,
  NoSuggestedText,
  SuggestedSearchIconBox,
  SuggestedTextItem,
  SuggestedTextList,
  SuggestedTextsTitle,
  SuggestedTextsWrapper,
} from "./styled"
import SmallSearchIcon from "components/Icons/SmallSearchIcon"
import Highlighter from "react-highlight-words"
import NoSuggestedIcon from "./NoSuggestedIcon"

const SuggestedSearchTexts = ({
  suggestedTexts,
  keyword,
  onSelect,
  isNoSuggestedSearchTexts,
  headerStyle = {},
  style = {},
}: {
  suggestedTexts: string[]
  keyword: string
  onSelect: (suggestedText: string) => void
  isNoSuggestedSearchTexts: boolean
  headerStyle?: React.CSSProperties
  style?: React.CSSProperties 
}) => {
  return (
    <SuggestedTextsWrapper style={style}>
      <SuggestedTextsTitle style={headerStyle}>
        Suggested searches
      </SuggestedTextsTitle>

      {isNoSuggestedSearchTexts ? (
        <NoSuggestedBox>
          <NoSuggestedIcon />
          <NoSuggestedText> No suggestions found</NoSuggestedText>
        </NoSuggestedBox>
      ) : (
        <SuggestedTextList>
          {suggestedTexts.map((text) => (
            <SuggestedTextItem key={text} onClick={() => onSelect(text)}>
              <SuggestedSearchIconBox>
                <SmallSearchIcon />
              </SuggestedSearchIconBox>

              <Highlighter
                highlightClassName="high-light-text"
                searchWords={keyword.split(" ")}
                autoEscape={true}
                textToHighlight={text}
              ></Highlighter>
            </SuggestedTextItem>
          ))}
        </SuggestedTextList>
      )}
    </SuggestedTextsWrapper>
  )
}

export default SuggestedSearchTexts
